export default __webpack_public_path__ + "static/media/Sitewide cta acf.dbbcb931.jpg";